export default "/packs/images/hand~1c72d3027845b50c027948d3956b7278.png";